import { formatDistanceToNow, parseISO, format } from "date-fns";
import { zhCN } from "date-fns/locale";

export function formatDate(dateStr: string): string {
  try {
    const date = parseISO(dateStr);
    return format(date, "yyyy-MM-dd");
  } catch {
    return dateStr;
  }
}

export function formatRelative(dateStr: string): string {
  try {
    const date = parseISO(dateStr);
    return formatDistanceToNow(date, { addSuffix: true, locale: zhCN });
  } catch {
    return dateStr;
  }
}

/** X 轴紧凑时间标签：2025Q1→25Q1, 2025-01→25M1, 2025Y→25Y, 2025H1→25H1 */
export function shortPeriodLabel(period: string): string {
  // 季度：2025Q1 → 25Q1
  const sq = period.match(/^(\d{2})(\d{2})(Q\d)$/);
  if (sq) return `${sq[2]}${sq[3]}`;
  // 月度：2025-01 → 25M1
  const mo = period.match(/^(\d{2})(\d{2})-(\d{2})$/);
  if (mo) return `${mo[2]}M${Number(mo[3])}`;
  // 年度：2025Y → 25Y
  const yr = period.match(/^(\d{2})(\d{2})Y$/);
  if (yr) return `${yr[2]}Y`;
  // 半年：2025H1 → 25H1
  const hf = period.match(/^(\d{2})(\d{2})(H\d)$/);
  if (hf) return `${hf[2]}${hf[3]}`;
  // 累计季度：2025Q1-Q4 → 25Q1-Q4
  const cumQ = period.match(/^(\d{2})(\d{2})(Q\d-Q\d)$/);
  if (cumQ) return `${cumQ[2]}${cumQ[3]}`;
  return period;
}
